export default class PostForm {

    cleanAndSend(article) {
        const copy = Object.assign({}, article);
        const {reference, id, sections} = copy;
        copy["key"] = id;
        copy.id = null;
        copy.reference = null;
        Object.keys(sections).map(function (key) {
            copy[key] = sections[key];
        });
        copy.sections = null;
        copy.dispatch = null;
        reference.child(id).set(copy);
    }

}


// WEBPACK FOOTER //
// ./src/admin/components/editor/presenters/PostForm.js